export default "__VITE_ASSET__fXVkor42__"